<script>
    import Header from './header.svelte';
    import Sidenav from './sidenav.svelte';
    import Footer from './footer.svelte';
    import Dashboard from './dashboard.svelte';
    import TrackTime from './invoicing/track-time.svelte';
    import Invoicing from './invoicing/invoicing.svelte';
    import Invoices from './invoicing/invoices.svelte';
    import Files from './invoicing/files.svelte';
    import Users from './users.svelte';
    import {Router, Route, Link} from "svelte-routing";

    import List from './crud/list.svelte';
</script>

<Router>
    <div id="wrapper">
        <Sidenav></Sidenav>
        <div id="content-wrapper" class="d-flex flex-column">
            <div id="content">
                <Header></Header>
                <Route path="/">
                    <Dashboard/>
                </Route>
                <Route path="/table/:table" let:params>
                    <List table="{params.table}"/>
                </Route>
                <Route path="/track">
                    <TrackTime/>
                </Route>
                <Route path="/invoicing">
                    <Invoicing/>
                </Route>
                <Route path="/invoices">
                    <Invoices/>
                </Route>
                <Route path="/files">
                    <Files/>
                </Route>
                <Route path="/users">
                    <Users/>
                </Route>
            </div>
            <Footer/>
        </div>
    </div>
</Router>
